module.exports = __webpack_public_path__ + "static/media/conversation.dabc01b1.svg";